import React from 'react';
import VInput from 'react-validation/build/input';

import arrow from './../../../../../../statics/img/arrow.svg';
import { COLLECT_INPUTS } from '../CollectMethod';

export function Input(props) {
  const {
    name,
    placeholder,
    disabled,
    currentInput,
    onSelectInput,
    disableDropdown,
    maxLength,
    value,
    onChange,
    type = 'text',
    options,
    validations,
    hasError,
    onToggleDropdown,
    showDropdown,
  } = props;

  return (
    <>
      <div
        className={`instapay_custom_input_content ${
          hasError ? 'instapay_input_error' : ''
        }`}
      >
        {COLLECT_INPUTS.MOBILE_NUMBER === currentInput && (
          <div className="instapay_custom_input_leading">
            <p>+20</p>
          </div>
        )}
        <VInput
          type={type}
          name={name}
          maxLength={maxLength}
          value={value}
          onChange={onChange}
          validations={validations}
          placeholder={placeholder}
          autoComplete="off"
          disabled={disabled}
        />
        {options && (
          <button
            type="button"
            className="instapay_custom_input_btn"
            onClick={onToggleDropdown}
            disabled={disableDropdown}
          >
            {currentInput}
            {!disableDropdown && (
              <img
                src={arrow}
                className="instapay_custom_input_arrow"
                data-toggled={showDropdown}
                alt="arrow"
              />
            )}
          </button>
        )}
        {showDropdown && (
          <div className="instapay_custom_input_dropdown_container">
            {options.map((item) => (
              <div
                key={item}
                className="instapay_custom_input_dropdown_content"
                onClick={() => onSelectInput(item)}
              >
                <div>{item}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
